import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  APPLICATION_LIST_RAW,
  APPLICATIONS_LIST,
  SELECTED_APPLICATION,
  LOADER_IDENTIFIER,
  CALL_STATE,
  CUSTOM_PROPERTIES,
  SYSTEM_PROPERTIES,
  ENTITLEMENTS_LIST,
  ENTITLEMENT_LIST_RAW,
  SELECTED_ENTITLEMENT,
  GLOBAL_ENTITLEMENTS_LIST,
  CHAIN_ENTITLEMENTS_LIST,
  CHAIN_ENTITLEMENTS_LIST_ADDED,
  CHAIN_ENTITLEMENTS_LIST_DELETED,
  BAO,
  LIST_IDENTIFIER,

  STE_ONE,
  STEP_TWO,
  STEP_THREE,
  STEP_FOUR,
  STEP_FIVE,
} = STATE_IDENTIFIER;

export default {
  [SELECTED_APPLICATION]: {},
  [APPLICATION_LIST_RAW]: [],
  [SELECTED_ENTITLEMENT]: {},
  [ENTITLEMENT_LIST_RAW]: [],
  [LOADER_IDENTIFIER]: false,
  [CALL_STATE]: IResponseState.PENDING,
  [BAO]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [STE_ONE]: {
    [APPLICATIONS_LIST]: {},
  },
  [STEP_TWO]: {
    [CUSTOM_PROPERTIES]: [],
    [SYSTEM_PROPERTIES]: [],
  },
  [STEP_THREE]: {
    [ENTITLEMENTS_LIST]: {},
  },
  [STEP_FOUR]: {
    [CUSTOM_PROPERTIES]: [],
    [SYSTEM_PROPERTIES]: [],
  },
  [STEP_FIVE]: {
    [LOADER_IDENTIFIER]: false,
    [GLOBAL_ENTITLEMENTS_LIST]: {},
    [CHAIN_ENTITLEMENTS_LIST]: [],
    [CHAIN_ENTITLEMENTS_LIST_ADDED]: [],
    [CHAIN_ENTITLEMENTS_LIST_DELETED]: [],
  },
};
